<template>
  <div class="cameraManagement-page">
    <div class="all-content-container" v-allow="'080202'" style="width: 100%">
      <div class="table-content-container">
        <div class="table-title-container">
          <div class="table-title-title">
            <h4>摄像头</h4>
            <el-button type="primary" class="addBtn" @click="addVideo">添加</el-button>
            <!-- <router-link to="addCameraManagement">
              <el-button type="primary" class="addBtn">添加</el-button>
            </router-link> -->
          </div>
          <div class="table-content-title">
            <el-form :inline="true" class="demo-form-inline">
              <el-form-item label="设备名称：">
                <el-input v-model="name" placeholder="请输入设备名称" clearable maxlength="20"></el-input>
              </el-form-item>
              <el-form-item label="设备编码：">
                <el-input v-model="code" placeholder="请输入设备编码" clearable maxlength="20"></el-input>
              </el-form-item>
              <el-form-item label="所属分组：">
                <el-cascader @change="changeTreeItem" :show-all-levels="false" v-model="groupId" :options="departList"
                  :props="optionProps" clearable placeholder="请选择所属分组"></el-cascader>
              </el-form-item>
              <el-form-item class="mar-l">
                <el-button type="primary" @click="onSubmit">查询</el-button>
                <el-button @click="resetonSubmit">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="table-content">
          <div class="table-table">
            <el-table :data="tableData" style="width: 100%" :header-cell-style="{ background: '#f4f5f7' }">
              <el-table-column align="center" label="序号" width="95">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column prop="name" label="设备名称" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column prop="code" label="设备编码" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column prop="groupName" label="所属分组" align="center"></el-table-column>
              <!-- <el-table-column prop="sswg" label="所属网关" align="center"></el-table-column> -->
              <el-table-column prop="intervalTime" label="采集间隔时间" align="center" show-overflow-tooltip></el-table-column>
              <el-table-column prop="isOpen" label="工作状态" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.isOpen == 0">
                    <span class="show-line show-rline"></span>
                    停用
                  </div>
                  <div v-if="scope.row.isOpen == 1">
                    <span class="show-line show-bline"></span>

                    启用
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="300">
                <template slot-scope="scope">
                  <el-button type="text" :underline="false" size="small" class="marginLr"
                    @click="edit(scope.row.id)">编辑</el-button>
                  <el-button type="text" :underline="false" size="small" class="marginLr"
                    @click="deletes(scope.row.id)">删除</el-button>
                  <el-button type="text" :underline="false" size="small" class="marginLr" v-if="scope.row.isOpen == 1"
                    @click="onOrOffNumericalBth3(scope.row.id)">停用</el-button>
                  <el-button type="text" :underline="false" size="small" class="marginLr" v-if="scope.row.isOpen == 0"
                    @click="onOrOffNumericalBth2(scope.row.id)">启用</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="pagination-content-container" style="float: right; margin-top: 15px">
          <el-pagination background layout="prev, pager, next,jumper" class="pageTap"
            @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize"
            :total="total"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      total: 0,
      input: "",
      input1: "",
      input2: "",
      currentPage: 1,
      pagesize: 8,
      code: "",
      groupId: "",
      name: "",
      departList: [],
      optionProps: {
        value: "id",
        label: "name",
        children: "children",
        checkStrictly: true,
      },

      tableData: [],
    };
  },
  created() {
    this.getVideoList();
    this.getConfigGroupTree();
  },
  mounted() {
    this.getVideoList();
    this.getConfigGroupTree();
  },
  methods: {
    //i所属分组id
    changeTreeItem(val) {
      this.groupId = val[val.length - 1];
    },

    //清除
    empty() {
      this.code = ""; //设备编码
      this.groupId = ""; // 分组id
      this.name = ""; //名称
    },
    //  重置
    resetonSubmit() {
      this.empty();
      this.onSubmit();
    },
    //查询
    onSubmit() {
      this.getVideoList();
    },
    //分页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getVideoList();
    },
    //删除
    deletes(id) {
      this.$confirm("是否删除？", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.system
            .delfun(`/pc/objDeviceVideo/delVideo`, id)
            .then((res) => {
              if (res.code == 200) {
                this.getVideoList();
                this.$message({
                  type: "success",
                  message: res.msg,
                });
              } else {
                // this.$message.error(res.msg)
              }
            });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    //启用/停用
    onOrOffNumericalBth2(id) {
      this.$confirm("是否启用？", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.openOrCloseVideo(id);
        })
        .catch(() => {
          this.$message.info("已取消启用");
        });
    },
    onOrOffNumericalBth3(id) {
      this.$confirm("是否停用？", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.openOrCloseVideo(id);
        })
        .catch(() => {
          this.$message.info("已取消停用");
        });
    },
    //启用/停用 接口id
    openOrCloseVideo(id) {
      this.$api.system
        .openOrCloseVideo(id)
        .then((res) => {
          if (res.code == 200) {
            this.getVideoList();
            this.$message({
              type: "success",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    // 编辑
    edit(id) {
      this.$router.push({
        path: "addCameraManagement",
        query: {
          id: id,
        },
      });
    },
    //添加
    addVideo() {
      this.$router.push({
        path: "addCameraManagement",
        query: {},
      });
    },
    // 查询摄像头列表
    getVideoList() {
      this.$api.system
        .getVideoList(
          this.currentPage, //第几页，默认1
          this.pagesize, //默认展示多少条，默认10
          this.code, //设备编码
          this.groupId, // 分组id
          this.name //名称
        )
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
            this.total = res.count;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //查询设备分组树，查询1
    getConfigGroupTree() {
      this.$api.system
        .getConfigGroupTree(
          0, //主键id ，根据具体业务进行判定
        )
        .then((res) => {
          if (res.code == 200) {
            this.departList = res.data;
          } else {
            // this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/cameraManagement.scss";
</style>